import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './ui/tokens.css'
import './ui/base.css'

if (import.meta.env.DEV) void import('./demo/dev')

const container = document.getElementById('root')
if (!container) {
  throw new Error('找不到 #root 挂载点：检查 index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
